import React from "react";
import { connect } from "react-redux";

/*REDUX*/
import { set_value_layer } from "../../App/actions/layerActions";
import { set_value_properties } from "../../App/actions/propertiesActions";

/*PICTURE*/
import icon_data from "../../Assets/svg/icon_data_new.svg";
import icon_sini from "../../Assets/svg/icon_sini.svg";
import icon_toolbox from "../../Assets/svg/icon_tool_new.svg";

const SIDEBAR_MINI = ({
  set_value_layer,
  set_value_properties,
  properties,
}) => {
  const setMode = (value) => {
    set_value_layer({ key: "statistic_mode", value: value });
    set_value_properties({ key: "sidebar_right_status", value: true });
    set_value_properties({ key: "is_mobile_close", value: false });
    set_value_properties({ key: "sidebar_height", value: 500 });
  };

  const mode_map = properties?.mode_map;

  let tabs = [
    { value: "data", icon: icon_data, alt: "Data" },
    { value: "sini", icon: icon_sini, alt: "Sini" },
    { value: "toolbox", icon: icon_toolbox, alt: "Toolbox" },
  ];

  if (mode_map !== "editor") {
    tabs = tabs.filter((item) => item.value !== "sini");
  }

  // Check how many tabs we currently have to dynamically adjust styles
  const isTwoTabs = tabs.length === 2;

  return (
    <div
      style={{
        paddingLeft: "25px",
        paddingRight: "25px",
        display: "flex",
        justifyContent: "center", // Centers the inner container
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          // DYNAMIC GAP: Increase gap when there are fewer items to balance the empty space
          gap: isTwoTabs ? "60px" : "39px",
          // DYNAMIC WIDTH: Forces the container to wrap its children perfectly
          width: "fit-content",

          /* OPTIONAL: If you want the container itself to have a "pill" background:
          backgroundColor: "#f5f5f5",
          padding: "10px 25px",
          borderRadius: "50px", 
          */
        }}
      >
        {tabs.map((item, idx) => {
          return (
            <button
              key={idx}
              className="cursor_pointer"
              onClick={() => setMode(item.value)}
              style={{
                // If you want the *buttons* themselves to stretch into wide pills,
                // you could use: width: isTwoTabs ? "60px" : "36px"
                width: "36px",
                height: "36px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "18px",
                backgroundColor: "#fff",
                boxShadow: "0 2px 9px 0 rgba(0, 0, 0, 0.4)",
                border: "none", // Good practice to remove default browser button borders
              }}
            >
              <img
                src={item.icon}
                alt={item.alt}
                style={{ width: "20px", height: "20px" }}
              />
            </button>
          );
        })}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  layer: state.layer,
  auth: state.auth,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  set_value_layer,
  set_value_properties,
})(SIDEBAR_MINI);
